import { ThemeProvider, Box, styled } from '@mui/material';
import useTheme from 'hooks/ui/useTheme';
import DataRoomEdit from './DataRoomEdit';
import NoDataRoom from './NoDataRoom';
import api from 'lib/trpcClient';
import { useFund } from 'hooks/data/fund/useFund';
import { useParams } from 'react-router-dom';
import { Realm } from 'further-types/global';

const Container = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

const TrancheDataRoom: React.FC = () => {
  const { id: fundId } = useParams<{ id?: string }>();
  const { theme } = useTheme(true);
  const { get: getFund } = useFund(fundId);
  const { data: fundData, isFetching } = getFund;

  const { data, mutate: addDataRoom } = api.dataRoom.create.useMutation();

  const handleAddDataRoom = () => {
    if (!fundData?._id) return;
    addDataRoom({ realm: Realm.Eis, linkedToId: fundData._id });
  };

  const dataRoomId = fundData?.dataRoomId ?? data?.id;

  return (
    <ThemeProvider theme={theme}>
      {isFetching ? null : (
        <Container>
          {dataRoomId ? (
            <DataRoomEdit dataRoomId={dataRoomId} />
          ) : (
            <NoDataRoom onAddDataRoom={handleAddDataRoom} />
          )}
        </Container>
      )}
    </ThemeProvider>
  );
};

export default TrancheDataRoom;
